import { useState } from 'react';
import { supabase } from '../lib/supabase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) setError('Email o contraseña incorrectos');
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.emoji}>🍽️</div>
        <h1 style={styles.title}>Local de Comidas</h1>
        <p style={styles.subtitle}>Iniciá sesión para continuar</p>

        {error && <p style={styles.error}>{error}</p>}

        <form onSubmit={handleLogin} style={styles.form}>
          <input
            style={styles.input}
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: { display:'flex', justifyContent:'center', alignItems:'center', height:'100vh', background:'#1B2631' },
  card: { background:'#fff', borderRadius:16, padding:40, width:'100%', maxWidth:400, textAlign:'center', boxShadow:'0 10px 30px rgba(0,0,0,0.3)' },
  emoji: { fontSize:52, marginBottom:8 },
  title: { fontSize:26, fontWeight:'bold', color:'#1B2631', margin:'0 0 4px' },
  subtitle: { fontSize:14, color:'#888', marginBottom:24 },
  error: { background:'#FADBD8', color:'#C0392B', padding:'10px', borderRadius:8, marginBottom:12, fontSize:13 },
  form: { display:'flex', flexDirection:'column', gap:12 },
  input: { padding:'12px 14px', borderRadius:8, border:'1px solid #ddd', fontSize:15, outline:'none' },
  button: { padding:'13px', background:'#E67E22', color:'#fff', border:'none', borderRadius:8, fontSize:16, fontWeight:'bold', cursor:'pointer' },
};